var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "delete_FILL0_wght400_GRAD0_opsz48",
    d: "M10.525,24a1.494,1.494,0,0,1-1.5-1.5V8.25H8V6.75h4.7V6h6.6v.75H24v1.5H22.975V22.5a1.538,1.538,0,0,1-1.5,1.5ZM21.475,8.25H10.525V22.5h10.95Zm-8.3,12.1h1.5V10.375h-1.5Zm4.15,0h1.5V10.375h-1.5Zm-6.8-12.1v0Z",
    transform: "translate(-8 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.0928ecde3647824d4cf4d1efced63a3a.svg";
export { ForwardRef as ReactComponent };